import { Button, Grid, Image, Stack, Title } from '@mantine/core';
import { WalletIcon } from '@phosphor-icons/react';
import { PrivyProvider, usePrivy } from '@privy-io/react-auth';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

/**
 * APIs
 */
import { loginWithPrivy } from '@/apis/auth';

/**
 * Components
 */
import ComponentTheme from '@/components/theme';

const PageAuthPrivy: React.FC = () => {
    /**
     * Params
     */
    const [params] = useSearchParams();

    /**
     * Hooks
     */
    const navigate = useNavigate();

    const { authenticated, getAccessToken, login } = usePrivy();

    const { t } = useTranslation();

    /**
     * Requests
     */
    const { isPending, mutate } = useMutation({
        onSuccess: async ({ data }) => {
            const url = new URL(params.get('redirect')!);

            url.searchParams.set('access_token', data.access_token);

            window.location.href = url.toString();
        },
        mutationFn: loginWithPrivy,
    });

    /**
     * Effects
     */
    useEffect(() => {
        if (!authenticated) return;

        getAccessToken().then((accessToken) => {
            mutate({
                access_token: accessToken!,
            });
        });
    }, [authenticated]);

    useEffect(() => {
        if (params.get('redirect')) return;

        navigate('/');
    }, [params]);

    return (
        <Grid gap={0}>
            <Grid.Col span={6}>
                <Stack h="100dvh" justify="space-between" p="md">
                    <div></div>

                    <Stack gap={24} mx="auto" w={400}>
                        <Title mb={8} order={2}>
                            {t('loginOrSignup')}
                        </Title>

                        <Button
                            fullWidth
                            leftSection={<WalletIcon weight="bold" />}
                            loading={isPending}
                            size="md"
                            onClick={login}
                        >
                            {t('loginWithPrivy')}
                        </Button>
                    </Stack>

                    <ComponentTheme />
                </Stack>
            </Grid.Col>

            <Grid.Col span={6}>
                <Image h="100dvh" src="/auth/background.jpg" />
            </Grid.Col>
        </Grid>
    );
};

const PageAuthPrivyWrapper: React.FC = () => {
    return (
        <PrivyProvider
            appId="cmndcquje03fi0cl2xsb7vped"
            clientId="client-WY6XmE1SYnEdaSyAGvofKRC5tLdSrVvdi7bjeGomVAm2Y"
        >
            <PageAuthPrivy />
        </PrivyProvider>
    );
};

export default PageAuthPrivyWrapper;
